const normalizeKeyPart = (value) => {
  if (value === undefined || value === null || value === "") return "none";
  return String(value);
};

const getStorageKey = (namespace, facilityId, cycleId) =>
  `OmnioOffline:${namespace}:${normalizeKeyPart(facilityId)}:${normalizeKeyPart(cycleId)}`;

const safeParseArray = (raw) => {
  if (!raw || typeof raw !== "string") return [];
  try {
    const parsed = JSON.parse(raw);
    return Array.isArray(parsed) ? parsed : [];
  } catch (error) {
    console.warn("Unable to parse offline records", error);
    return [];
  }
};

export const readOfflineRecords = (namespace, facilityId, cycleId) => {
  if (typeof window === "undefined") return [];
  try {
    const key = getStorageKey(namespace, facilityId, cycleId);
    const raw = window.localStorage.getItem(key);
    return safeParseArray(raw);
  } catch (error) {
    console.warn("Unable to read offline records", namespace, error);
    return [];
  }
};

export const writeOfflineRecords = (namespace, facilityId, cycleId, rows) => {
  if (typeof window === "undefined") return;
  try {
    const key = getStorageKey(namespace, facilityId, cycleId);
    if (!rows || rows.length === 0) {
      window.localStorage.removeItem(key);
      return;
    }
    window.localStorage.setItem(key, JSON.stringify(rows));
  } catch (error) {
    console.warn("Unable to write offline records", namespace, error);
  }
};

export const upsertOfflineRecord = (namespace, facilityId, cycleId, record) => {
  if (!record || record.id === undefined || record.id === null) return;
  const existing = readOfflineRecords(namespace, facilityId, cycleId);
  const filtered = existing.filter((entry) => String(entry.id) !== String(record.id));
  writeOfflineRecords(namespace, facilityId, cycleId, [record, ...filtered]);
};

export const removeOfflineRecord = (namespace, facilityId, cycleId, recordId) => {
  if (recordId === undefined || recordId === null) return;
  const existing = readOfflineRecords(namespace, facilityId, cycleId);
  const filtered = existing.filter((entry) => String(entry.id) !== String(recordId));
  writeOfflineRecords(namespace, facilityId, cycleId, filtered);
};

export const clearOfflineRecords = (namespace, facilityId, cycleId) => {
  if (typeof window === "undefined") return;
  try {
    const key = getStorageKey(namespace, facilityId, cycleId);
    window.localStorage.removeItem(key);
  } catch (error) {
    console.warn("Unable to clear offline records", namespace, error);
  }
};

export const replaceOfflineRecords = (namespace, facilityId, cycleId, rows) => {
  if (!Array.isArray(rows) || rows.length === 0) {
    clearOfflineRecords(namespace, facilityId, cycleId);
    return;
  }
  writeOfflineRecords(namespace, facilityId, cycleId, rows);
};
